/**
 * Self-contained build-time flag for the Text block's INLINE "AI Assistant"
 * button (NEMESIS AI-04).
 *
 * WHY: the default placeholder toolbar rendered an "AI" button whose
 * aria-label was "AI Assistant (mocked)" — a visibly-present but NON-FUNCTIONAL
 * control (no real generation call; AI-spend rule). A mocked AI control should
 * not be exposed to users, so the button is gated OFF until a real inline-AI
 * implementation exists.
 *
 * Follows the app's env convention (mirrors InstantWheelPreview/featureFlag.js):
 * the flag defaults OFF and is flipped per environment via a REACT_APP_* build
 * var. When OFF the placeholder toolbar renders only the real formatting buttons
 * (B/I/U/S/•/1./🔗) — byte-identical to shipping *without* the mocked control.
 * The LIVE builder is unaffected either way: it overrides the whole rich-text
 * slot with the real Froala editor (Text/TextEditorSettings), which carries its
 * own real AI command — this flag only governs the deck/standalone placeholder.
 *
 * When a real inline AI Assistant lands, set
 * REACT_APP_INLINE_AI_ASSISTANT_ENABLED="true" to reveal the button.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const INLINE_AI_ASSISTANT_ENABLED = truthy(
  process.env.REACT_APP_INLINE_AI_ASSISTANT_ENABLED,
);
